import noneRuntime_3649XKMDwoXBvODeeO55qfDDT3Q_ElJ_45lBnR_45Nwx41J9g from '/home/snaumann/Development/public_html/ludwig-pfeiffer/site/node_modules/.pnpm/@nuxt+image@2.2.0_@nuxt+schema@4.6.2_@types+node@24.19.2_confbox@0.3.1_dotenv@17.4.2_gi_a08a7317a75f1d7c17e9c4d50b935acd/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime_36fHjbyxzaRv63XdaIOqtG6RuH0inNkV1CiFzZlkVilIg from '/home/snaumann/Development/public_html/ludwig-pfeiffer/api/vendors/gsmaterials/imgProvider.ts'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"none"} */
  provider: "none",
  providers: {
      ['none']: { setup: noneRuntime_3649XKMDwoXBvODeeO55qfDDT3Q_ElJ_45lBnR_45Nwx41J9g, defaults: true },
  ['gs']: { setup: gsRuntime_36fHjbyxzaRv63XdaIOqtG6RuH0inNkV1CiFzZlkVilIg, defaults: undefined }
  }
}
